import React from 'react';
import PropTypes from 'prop-types';

import { BadgeStyled } from './Badge.styled';

export const badgeSize = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  DEFAULT: 'default',
};

function Badge({ className, text, url, ...props }) {
  if (url) {
    return (
      <a href={url}>
        <BadgeStyled url={url} className={className} {...props}>
          {text}
        </BadgeStyled>
      </a>
    );
  }
  return (
    <BadgeStyled url={url} className={className} {...props}>
      {text}
    </BadgeStyled>
  );
}

export default Badge;

Badge.defaultProps = {
  size: badgeSize.XSMALL,
};

Badge.propTypes = {
  className: PropTypes.string,
  /**
   * Badge text
   */
  text: PropTypes.string.isRequired,
  /**
   * Url for showing link with the badge
   */
  url: PropTypes.string,
  size: PropTypes.oneOf(Object.values(badgeSize)),
  /**
   * Custom color for background
   */
  customBgColor: PropTypes.string,
};
